import axios from 'axios'
import { toast } from 'react-toastify'
import { create } from 'apisauce'

const axiosInstance = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

const defaultErrorMessage = 'Algo salió mal, por favor intenta de nuevo más tarde.'

axiosInstance.interceptors.response.use((response) => {
  response?.data?.message && toast.success(response.data.message)

  return response
}, ({ response, ...error }) => {
  if (response.status === 401) {
    if (response?.data?.type !== 'pundit') {
      location.href = '/sign_in'
    }
  }

  const errors = response?.data?.errors || []
  errors.length > 0 ? errors.forEach((errorMessage) => toast.error(errorMessage)) : toast.error(response.statusText || defaultErrorMessage)
  return error
})
export default create({
  axiosInstance
})
